import gql from 'graphql-tag';

export const GET_EXERCISES_BY_LESSON = gql`
  query ExercisesByLesson($lessonId: MOID!) {
    exercisesByLesson(lessonId: $lessonId) {
      _id
      name
      duration
      position
      questions {
        _id
        name
        type
        description
        responses {
          isRight
          key
          response
        }
      }
    }
  }
`;

export const GET_EXERCISE_BY_ID = gql`
  query Exercise($id: MOID!) {
    exercise(id: $id) {
      _id
      name
      duration
      position
    }
  }
`;

export const REMOVE_EXERCISE = gql`
  mutation RemoveExercise($id: MOID!) {
    removeExercise(id: $id)
  }
`;
